import React from 'react';

const Leverandorer = ({ width = '16', height = '16', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_208_3147)">
      <path
        d="M2.72925 9.91671C2.72925 11.3146 3.28457 12.6553 4.27304 13.6437C5.26151 14.6322 6.60217 15.1875 8.00008 15.1875C9.39799 15.1875 10.7387 14.6322 11.7271 13.6437C12.7156 12.6553 13.2709 11.3146 13.2709 9.91671C13.2709 8.5188 12.7156 7.17814 11.7271 6.18967C10.7387 5.20119 9.39799 4.64587 8.00008 4.64587C6.60217 4.64587 5.26151 5.20119 4.27304 6.18967C3.28457 7.17814 2.72925 8.5188 2.72925 9.91671Z"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M8.3392 6.90878L9.13653 8.47917H10.4954C10.5703 8.47734 10.6439 8.49813 10.7067 8.53881C10.7695 8.5795 10.8186 8.63818 10.8475 8.7072C10.8764 8.77622 10.8838 8.85235 10.8688 8.92565C10.8537 8.99896 10.8169 9.06601 10.7631 9.11806L9.51539 10.346L10.2067 11.9336C10.2371 12.0064 10.244 12.0868 10.2263 12.1636C10.2086 12.2405 10.1672 12.3098 10.108 12.3618C10.0487 12.4138 9.97464 12.4459 9.89618 12.4536C9.81771 12.4613 9.73882 12.4441 9.67064 12.4045L7.99995 11.4621L6.32925 12.4019C6.26107 12.4415 6.18218 12.4587 6.10372 12.4511C6.02525 12.4434 5.95117 12.4113 5.89194 12.3592C5.83271 12.3072 5.79131 12.2379 5.7736 12.1611C5.75589 12.0842 5.76275 12.0038 5.79322 11.9311L6.4845 10.3434L5.23675 9.1155C5.18299 9.06346 5.14617 8.9964 5.13113 8.9231C5.11608 8.8498 5.1235 8.77366 5.15242 8.70464C5.18134 8.63563 5.23041 8.57694 5.29322 8.53626C5.35602 8.49557 5.42964 8.47479 5.50445 8.47661H6.86336L7.66134 6.90623C7.69414 6.8447 7.74311 6.79328 7.80297 6.75751C7.86283 6.72175 7.93131 6.70299 8.00104 6.70325C8.07077 6.70351 8.1391 6.72279 8.19869 6.75901C8.25828 6.79522 8.30686 6.84701 8.3392 6.90878Z"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M5.60425 0.8125L6.68653 4.81067"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.40447 7.33428L0.8125 0.8125"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3958 0.8125L9.31348 4.81067"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5955 7.33428L15.1874 0.8125"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_208_3147">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Leverandorer;
